import { Tooltip, TooltipProps } from "@mui/material";

export default function TooltipForForm(props: TooltipProps) {
  const { children, placement = "top-start", ...rest } = props;
  return (
    <Tooltip
      placement={placement}
      {...rest}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
    >
      <div>{props.children}</div>
    </Tooltip>
  );
}
